import { B2B_LEGAL_ENTITY_STATUS, B2B_USER_ROLE } from '@lentau/profile/organizations/legal-entity/shared/enums/enum';
import { B2BLegalEntityState } from '@lentau/profile/organizations/legal-entity/shared/interfaces/interface';
import { LegalEntityType } from 'angular-api-gateway/v1/model/legalEntityType';

export const legalEntityInitialState: B2BLegalEntityState = {
  legalEntity: {
    legalEntityId: '',
    siebelId: '',
    name: '',
    alias: '',
    inn: '',
    kpp: '',
    form: '',
    bank: {
      bic: '',
      account: '',
      corrAccount: '',
    },
    addressLegal: '',
    phone: '',
    proCardNumber: '',
    email: '',
    emailChecked: true,
    emailConfirm: '',
    contractNumber: '',
    owner: {
      passportId: '',
      siebelId: '',
      name: '',
      phone: '',
      email: '',
      proCardNumber: '',
      role: B2B_USER_ROLE.user,
    },
    manager: {
      person: {
        passportId: '',
        siebelId: '',
        name: '',
        phone: '',
        email: '',
        proCardNumber: '',
        role: B2B_USER_ROLE.manager,
      },
      data: {
        id: '',
        name: '',
        workingHours: '',
        mobilePhone: '',
        workPhone: '',
        addPhone: '',
        email: '',
      },
    },
    status: B2B_LEGAL_ENTITY_STATUS.active,
    egais: false,
    mercury: false,
    edo: false,
    type: LegalEntityType.Main,
    regDate: null,
  },
  loading: false,
  alcoOwnNeedsPostSuccessCount: 0,
  alcoOwnNeedsPostErrorCount: 0,
  alcoOwnNeedsPostErrorMessage: '',
};
